
<template>
    <div>
        <div>
            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div class="container" v-if="! isLoadingBlade">
                <div class="row">
                    <div class="col-lg-2">
                        <base-input alternative="">
                            <select
                                class="form-control form-control-alternative" 
                                v-model="page"
                                @change="getPageItems()"
                            >
                                <option
                                    v-for="number in pageNumbers"
                                    :key="number"
                                    :value="number"
                                >
                                    {{ number }}
                                </option>
                            </select>
                        </base-input>
                    </div>
                    <div class="col-lg-10 text-right">
                        <div v-if="! hasExportPages">
                            <button
                                :class="'btn btn-lg btn-'+ (showFilters ? 'danger' : 'primary')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayFilters()"
                            >
                                <i :class="'fa fa-'+(showFilters ? 'times' : 'sort')"></i>
                                {{ showFilters ? 'Remove Filters' : 'Filters Report'}}
                            </button>

                            <button
                                class="btn btn-lg btn-success"
                                @click="exportHospitalReport()"
                                v-if="records && records.length > 0"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-file-export"></i>
                                {{ isLoading ? 'Please Wait...' : 'Export Report'}}
                            </button>
                        </div>

                        <div v-if="hasExportPages">
                            <button
                                :class="'btn btn-lg btn-'+ (showFilters ? 'danger' : 'primary')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayFilters()"
                            >
                                <i :class="'fa fa-'+(showFilters ? 'times' : 'sort')"></i>
                                {{ showFilters ? 'Remove Filters' : 'Filters Report'}}
                            </button>
                            <button
                                :class="'btn btn-lg btn-'+ (showExportPages ? 'danger' : 'success')"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                @click="displayExportPages()"
                            >
                                <i :class="'fa fa-'+(showExportPages ? 'times' : 'sort')"></i>
                                {{ showExportPages ? 'Remove Export Pages' : 'Show Export Pages'}}
                            </button>
                        </div>
                    </div>

                    <div class="col-lg-12" v-if="hasExportPages && showExportPages">
                        <hr>
                        <form @submit.prevent="exportHospitalPagesReport">
                            <input
                                v-if="(item != 'limit')"
                                v-for="(value, item) in filters"
                                :key="item"
                                type="hidden"
                                :name="item"
                                :value="value"
                            />

                            <input
                                type="hidden"
                                name="limit"
                                :value="exportPerSheet"
                            />

                            <div class="col-lg-12 text-center">
                                <h3 class="text-danger">
                                    Note: Maximum of {{ exportPerSheet }} record(s) per export.
                                </h3>
                                <base-input label="Select Range of Records" required>
                                    <select
                                        class="form-control form-control-alternative"
                                        name="export_page"
                                        @change="enableExportPageButton()"
                                        required
                                    >
                                        <option  value="null" disabled selected>
                                            ---Select One---
                                        </option>
                                        <option
                                            v-for="page in exportPages"
                                            :key="page"
                                            :value="page"
                                        >
                                            Page {{ page }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>

                            <button
                                class="btn btn-lg btn-success btn-block"
                                style="margin-top: 10px;"
                                nativeType="submit"
                                v-if="records && records.length > 0"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges || disableExportPageButton"
                            >
                                <i class="fa fa-file-export"></i>
                                {{ isLoading ? 'Please Wait...' : 'Export Page'}}
                            </button>
                        </form>
                        <hr>
                    </div>
                </div>
            </div>

            <div class="container" v-if="showFilters && ! isLoadingBlade">
                <hr>
                <h3 class="mb-0 text-uppercase text-center" v-html="filteredTitle"></h3>
                <hr v-if="! isFiltered">
                <div class="row" v-if="! isFiltered">
                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Training Type"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.type"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="medical">Medical Training</option>
                                <option value="dental">Dental Training</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Hospital Status"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.status"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="enable">Active</option>
                                <option value="disable">Deactivated</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Hospital Type"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.hospital_type"
                            >
                                <option :value="null" disabled>--- Select One ---</option>
                                <option value="private">Private Hospital</option>
                                <option value="federal">Federal Hospital</option>
                                <option value="state">State Hospital</option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Current Quota"
                            input-classes="form-control-alternative text-capitalize"
                            placeholder="Enter Quota"
                            v-model="filters.quota"
                            type="number"
                        />
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="State Location"
                        >
                            <autocomplete
                                input-class="form-control form-control-alternative"
                                placeholder="Type and Search for State Location"
                                showNoResults
                                :source="locations.states"
                                v-model="filters.state_id"
                            >
                            </autocomplete>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Region (Geo-political)"
                        >
                            <autocomplete
                                input-class="form-control form-control-alternative"
                                placeholder="Type and Search for Region"
                                showNoResults
                                :source="locations.regions"
                                v-model="filters.region_id"
                            >
                            </autocomplete>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            label="Last Visitation Date"
                        >
                            <flat-picker
                                slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                v-model="filters.visit_date"
                                :config="{allowInput: false}"
                                class="form-control datepicker"
                            >
                            </flat-picker>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input alternative=""
                            label="Last Visitation Year"
                        >
                            <select
                                class="form-control form-control-alternative"
                                v-model="filters.visit_year"
                            >
                                <option  value="null" disabled>---Select One---</option>
                                <option
                                    v-for="(year, index) in years"
                                    :key="index"
                                    :value="year"
                                >
                                    {{ year }}
                                </option>
                            </select>
                        </base-input>
                    </div>

                    <div class="col-lg-4">
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            label="Accreditation Expiry Date"
                        >
                            <flat-picker
                                slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                v-model="filters.expiry_date"
                                :config="{allowInput: false}"
                                class="form-control datepicker"
                            >
                            </flat-picker>
                        </base-input>
                    </div>

                    <div class="col-lg-12">
                        <button
                            class="btn btn-lg btn-info btn-block"
                            :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            @click="applyFilters()"
                        >
                            <i class="fa fa-check"></i>
                            Apply Filters
                        </button>
                        <button
                            class="btn btn-lg btn-danger btn-block"
                            @click="displayFilters()"
                        >
                            <i class="fa fa-times"></i>
                            Remove Filters
                        </button>
                    </div>
                </div>
                <hr>
            </div>

            <!-- import Payment Report Data template here -->
            <HospitalReportingData
                :records="records"
                :hasPagination="hasPagination"
                :pagination="pagination"
                :paginate="paginate"
                :privileges="privileges"
                :accreditedCount="accreditedCount"
                :waitingCount="waitingCount"
                v-if="! isLoadingBlade"
            />

        </div>

        <div
            class="col-sm-12 text-center"
            v-if="showErrorStatus"
        >
            <base-alert :type="errorType">
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
            </base-alert>
        </div>

    </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import HospitalReportingData from './HospitalReportingData';
  import swal from 'sweetalert2';// import sweet alert
  import Autocomplete from 'vuejs-auto-complete';

  export default {
    name: 'HospitalReporting',
    props: ['privileges'],
    components: {
        HospitalReportingData,
        flatPicker,
        Autocomplete
    },
    data() {
      return {
        payment: [],
        showErrorStatus: false,
        errorType: null,
        errorMsg: null,
        isLoadingBlade: true,
        records: [],
        paginatedItems: [],
        pagination: {
            total: null,
            prev_page_url: null,
            next_page_url: null,
            current_page: null,
            last_page: null,
            number: 1,
            from: 0,
            to: null,
            perPage: this.$store.state.url.perPage // get per page count
        },
        filters: {
            type: null,
            status: null,
            quota: null,
            visit_date: null,
            expiry_date: null,
            hospital_type: null,
            visit_year: null,
            state_id: null,
            region_id: null,
            limit: this.$store.state.url.perPage // get per page count
        },
        accreditedCount: null,
        waitingCount: null,
        page: 1,
        showFilters: false,
        isFiltered: false,
        showExportPages: false,
        disableExportPageButton: true,
        filteredTitle: 'Filtered Training Hospitals Report',
        isLoading: false
      }
    },
    filters: {
        formatDate(value) {
            return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
        },
    },
    computed: {
        ...mapGetters(['loadingBladeUrl', 'getExportHospitalReportUrl', 'user', 'exportPerSheet', 'locations']),
        hasPagination() {
            return this.pagination.next_page_url || this.pagination.prev_page_url ? true : false;
        },
        pageNumbers() {
            let start = 1;
            let end = this.pagination.last_page;
            let pages = [];
            for (let i = start; i <= end; i++ ) {
                pages.push(i);
            }
            return pages;
        },
        hasExportPages() {
            let divider = this.$store.state.url.exportPerSheet;
            return this.pagination.total > divider;
        },
        exportPages() {
            let divider = this.$store.state.url.exportPerSheet;
            let pages = Math.ceil(this.pagination.total / divider);
            return pages;
        },
        years() {
            let startYear = 2022;// start from 2022
            let currentYear = parseInt(moment().format('YYYY')) + 2;
            let years = [];
            for (let i = startYear; i <= currentYear; i++ ) {
                years.push(i);
            }
            return years;
        }
    },
    methods: {
        ...mapActions(['getTrainingHospitalsReporting', 'getPaginatedPaymentItems', 'getLocations', 'downloadAssessmentFiles']),
        applyFilters() {// apply filters function
            let status = this.validFilterInputs();
            this.showErrorStatus = false;
            if(status) {
                this.preloader();// show loading
                let data = this.filters;
                data.filter = true;
                this.getTrainingHospitalsReporting(data).then((res) => {// get transactions
                    this.isLoadingBlade = false;
                    this.setPages(res);//set data
                    this.isFiltered = true;
                    this.getFilteredTitle();// set filtered title
                    swal.close();
                }).
                catch(() => {
                    this.records = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                let msg = 'Kindly select one of the filter actions, and try again';
                swal.fire('Invalid Selection', msg, 'warning');
            }
        },
        getFilteredTitle() {// set filtered payment title
            let data = this.filters;
            this.filteredTitle += data.type ?  `, Training Type -> <em class="text-danger">${data.type}</em>` : '';
            this.filteredTitle += data.status ?  `, Hospital Status -> <em class="text-danger">${
                                    (data.status == 'enable') ? 'Active' : 'Deactivated' }</em>` : '';
            this.filteredTitle += data.hospital_type ?  `, Hospital Type -> <em class="text-danger">${data.hospital_type}</em>` : '';
            this.filteredTitle += data.quota ?  `, Current Quota -> <em class="text-danger">${data.quota}</em>` : '';
            if(data.state_id) {// add state location
                let state = this.locations.states.filter(item => item.id == data.state_id);
                if(state && state.length > 0) {
                    this.filteredTitle += ', State Location -> <em class="text-danger">'+state[0].name+'</em>';
                }
            }
            if(data.region_id) {// add region location
                let region = this.locations.regions.filter(item => item.id == data.region_id);
                if(region && region.length > 0) {
                    this.filteredTitle += ', Region (Geo-political) -> <em class="text-danger">'+region[0].name+'</em>';
                }
            }
            this.filteredTitle += data.visit_date ?  `, Last Visitation Date -> <em class="text-danger">${
                                    this.formatRangeDate(data.visit_date)}</em>` : '';
            this.filteredTitle += data.visit_year ?  `, Last Visitation Year -> <em class="text-danger">${data.visit_year}</em>` : '';
            this.filteredTitle += data.expiry_date ?  `, Accreditation Expiry Date -> <em class="text-danger">${
                                    this.formatRangeDate(data.expiry_date)}</em>` : '';
            this.filteredTitle += ' Hospitals Only';
        },
        formatRangeDate(value) {// format range date
            return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
        },
        validFilterInputs() {
            let data = this.filters;
            return data.quota || data.type || data.status || data.visit_date || data.expiry_date 
                    || data.hospital_type || data.visit_year || data.state_id || data.region_id;
        },
        displayFilters() {// diplay filters template
            this.emptyFilters();// empty filters
            this.loadPayments();// reload payments
            this.showExportPages = false;
            return this.showFilters = ! this.showFilters;
        },
        emptyFilters() {// empty filters
            this.filters = {
                type: null,
                status: null,
                quota: null,
                visit_date: null,
                expiry_date: null,
                hospital_type: null,
                visit_year: null,
                state_id: null,
                region_id: null,
                limit: this.$store.state.url.perPage // get per page count
            };
            this.isFiltered = false;
            this.filteredTitle = 'Filtered Training Hospitals Report';
            this.accreditedCount = null;
            this.waitingCount = null;
        },
        loadPayments() {// load details
            let data = { limit : this.pagination.perPage, filter : false };
            this.isLoadingBlade = true;
            this.showErrorStatus = false;
            this.getTrainingHospitalsReporting(data).then((res) => {// get users
                this.isLoadingBlade = false;
                this.setPages(res);//set data
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        setPages(data) {// set paginated function
            this.accreditedCount = data.accredited_count;// get accredited count
            this.waitingCount = data.waiting_count;// get waiting acreditation count
            let res = data.hospitals;
            this.records = [];
            this.paginatedItems = res.data;
            this.records = this.paginatedItems;
            this.pagination.from = res.from;
            this.pagination.to = res.to;
            this.pagination.total = res.total;
            this.pagination.current_page = res.current_page;
            this.pagination.last_page = res.last_page;
            this.pagination.prev_page_url = res.prev_page_url;
            this.pagination.next_page_url = res.next_page_url;
            this.isLoadingBlade = false;
            this.emptyRecordsMsg();//show empty msg
        },
        paginate() {// paginate function
            this.showErrorStatus = false;
            let url = (this.pagination.number > this.pagination.current_page) ?
                this.pagination.next_page_url : this.pagination.prev_page_url;
            if(url) {// make api call
                this.isLoadingBlade = true
                this.getPaginatedPaymentItems(url).then((res) => {// get users
                    this.pagination.number = res.hospitals.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.users = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                this.records = this.paginatedItems;
            }
        },
        emptyRecordsMsg() {
            return this.records && this.records.length == 0 ? this.showEmptyMsg() : false;
        },
        showEmptyMsg() {// show empty msg
            this.showErrorStatus = true;
            this.errorType = 'warning';
            this.errorMsg = 'No Hospitals recorded yet!!!';
        },
        displayExportPages() {
            this.showFilters = false;
            return this.showExportPages = ! this.showExportPages;
        },
        getPageItems() {
            let url = this.pagination.next_page_url ?
                        this.pagination.next_page_url : this.pagination.prev_page_url;
            let exploded = url.split('&');
            let newUrl = exploded[0]+'&'+exploded[1]+'&'+exploded[2]+'&'+exploded[3]+'&page='+this.page;
            this.isLoadingBlade = true
            this.getPaginatedPaymentItems(newUrl).then((res) => {// get records
                this.pagination.number = res.hospitals.current_page;
                this.setPages(res);
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        enableExportPageButton() {
            return this.disableExportPageButton = false;
        },
        preloader() {
            return  swal.fire({
                title: 'Please Wait...',
                html: 'Trying to fetch data from <b>server</b>',
                // timer: 2000,
                timerProgressBar: true,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });
        },
        exportHospitalReport() {
            this.isLoading = true;
            const data = { 
                ...this.filters, 
                admin_id: this.user.id, 
                url : this.getExportHospitalReportUrl,
                contentType : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                fileName :  'hospitals-export.xlsx',
                msg : 'Failed to export Hospitals report sheet:'
            };
            return this.downloadAssessmentFiles(data).then((res) => {// download file
                this.isLoading = res; // stop loading
            });
        },
        exportHospitalPagesReport(event) {
            this.isLoading = true;
            const formData = new FormData(event.target);
            const payload = Object.fromEntries(formData.entries());// get entries

            const data = { 
                ...payload, 
                admin_id: this.user.id, 
                url : this.getExportHospitalReportUrl,
                contentType : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                fileName :  'hospitals-export.xlsx',
                msg : 'Failed to export Hospitals report sheet:'
            };
            return this.downloadAssessmentFiles(data).then((res) => {// download file
                this.isLoading = res; // stop loading
            });
        }
    },
    mounted() {
        this.loadPayments();
        this.getLocations();
    }
  };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
